import api from './api';
import bookkeeping from './bookkeeping/index.js';
import crm from './crm/index.js';
import external from './external/index.js';
import person from './person/index.js';
import staff from './staff/index.js';
import upstream from './upstream';

export default {
  api,
  bookkeeping,
  crm,
  person,
  staff,
  external,
  upstream,
};
